import { createSelector } from 'reselect';
import { Tenant } from '../api/types';
import { RootState } from '../store/store';

const stateKey = 'authentication';

const permissionListSelector = (state: RootState): string[] => state.legacy[stateKey].permissions;
const rolesListSelector = (state: RootState): string[] => state.legacy[stateKey].roles || [];
export const tenantSelector = (state: RootState): Tenant|null => state.legacy[stateKey].tenant;
export const permissionsLoadedSelector = (state: RootState): boolean => state.legacy[stateKey].permissionsLoaded;

export const makePermissionListSelector = () => {
    return createSelector([permissionListSelector], (permissionListSelector): string[] => {
        return permissionListSelector;
    });
};

export const makeHasPermissionSelector = (permission: string) => {
    return createSelector([permissionListSelector], (permissionListSelector): boolean => {
        return permissionListSelector.includes(permission);
    });
};

export const makeHasRoleSelector = (role: string) => {
    const lowerCaseRole = role.toLowerCase();
    return createSelector([rolesListSelector], (rolesList): boolean => {
        return rolesList.some((r) => r.toLowerCase().includes(lowerCaseRole));
    });
};
